import React from 'react';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';

export const getTagsOuvidoriaColumns = ({ onEdit, onDelete } = {}) => [
  {
    id: 'nomeTag',
    header: 'Nome da Tag',
    accessorKey: 'nomeTag',
    size: 220,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={60} />,
  },
  {
    id: 'descricao',
    header: 'Descricao',
    accessorKey: 'descricao',
    size: 320,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={120} />,
  },
  {
    id: 'dataCriacao',
    header: 'Data de Criacao',
    accessorKey: 'dataCriacaoFormatada',
    size: 180,
    enableSorting: true,
    cell: ({ getValue }) => <span>{getValue() || '-'}</span>,
  },
  {
    id: 'prioridade',
    header: 'Prioridade',
    accessorKey: 'prioridadeLabel',
    size: 120,
    enableSorting: true,
    cell: ({ row }) => (
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: 58,
          padding: '4px 10px',
          borderRadius: 999,
          fontSize: 12,
          fontWeight: 700,
          color: row.original.prioridade ? '#166534' : '#475467',
          background: row.original.prioridade ? '#dcfce7' : '#f2f4f7',
        }}
      >
        {row.original.prioridade ? 'Sim' : 'Nao'}
      </span>
    ),
  },
  ...(onEdit || onDelete
    ? [
        {
          id: 'actions',
          header: 'Acoes',
          size: 160,
          enableSorting: false,
          cell: ({ row }) => (
            <div style={{ display: 'flex', gap: '6px' }}>
              {onEdit && (
                <ButtonWithLoading
                  size="sm"
                  variant="outline-primary"
                  onClick={event => {
                    event.stopPropagation();
                    onEdit(row.original.id);
                  }}
                >
                  Editar
                </ButtonWithLoading>
              )}
              {onDelete && (
                <ButtonWithLoading
                  size="sm"
                  variant="outline-danger"
                  onClick={event => {
                    event.stopPropagation();
                    onDelete(row.original.id);
                  }}
                >
                  Excluir
                </ButtonWithLoading>
              )}
            </div>
          ),
        },
      ]
    : []),
];
